// extracted by mini-css-extract-plugin
module.exports = {"error":"D_ct"};